import FooterListHeader from './FooterListHeader.js'
import FooterListItem from './FooterListItem.js'

const FooterList = ({ title, items }) => (
    <ul className="footer-list col-sm-3">
        <FooterListHeader header={title} />
        {items.map((item, index) => (
            <FooterListItem key={index} {...item} />
        ))}
    </ul>
)

FooterList.propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
}

export default FooterList
